export const formatClient = (firstName, lastName, mrn) => {
  return `${mrn ? mrn + " - " : ""}${firstName ? firstName : ""} ${
    lastName ? lastName : ""
  }`;
};

export const formatEoc = (firstName, lastName, mrn, episodeOfCareID) => {
  return `${mrn ? mrn : ""}${episodeOfCareID ? "-" + episodeOfCareID : ""} ${
    firstName ? firstName : ""
  } ${lastName ? lastName : ""}`;
};

export const formatMrn = (mrn, episodeOfCareID) => {
  return `${mrn ? mrn : ""}${episodeOfCareID ? "-" + episodeOfCareID : ""}`;
};
